(() => {
  const initialize = () => {
    document.querySelectorAll('[data-pino-enquiry-link]').forEach((link) => {
      if (link.dataset.pinoEnquiryInitialized === 'true') return;
      link.dataset.pinoEnquiryInitialized = 'true';
      link.addEventListener('click', () => {
        const product = link.closest('product-info');
        const productForm = product?.querySelector('form[action*="/cart/add"]');
        const selectedVariant = productForm?.querySelector('input[name="id"]') || product?.querySelector('input[name="id"]');
        const selectedQuantity = product?.querySelector('input[name="quantity"]');
        try {
          const url = new URL(link.href, window.location.origin);
          if (url.origin !== window.location.origin) return;
          const variantValue = selectedVariant ? selectedVariant.value : url.searchParams.get('variant');
          const quantityValue = selectedQuantity ? selectedQuantity.value : url.searchParams.get('quantity');
          if (/^\d{1,20}$/.test(variantValue || '')) url.searchParams.set('variant', variantValue);
          else url.searchParams.delete('variant');
          if (/^[1-9]\d{0,8}$/.test(quantityValue || '')) url.searchParams.set('quantity', quantityValue);
          else url.searchParams.delete('quantity');
          const intent = link.dataset.pinoEnquiryIntent;
          if (['inquiry', 'hold', 'waitlist'].includes(intent)) url.searchParams.set('intent', intent);
          link.href = url.href;
        } catch {}
      });
    });
    const params = new URLSearchParams(window.location.search);
    const uniqueParam = (key) => {
      const values = params.getAll(key);
      return values.length === 1 ? values[0] : '';
    };

    document.querySelectorAll('[data-pino-product-enquiry]').forEach((field) => {
      if (field.dataset.pinoInitialized === 'true') return;
      const form = field.closest('form');
      const copyElement = field.querySelector('[data-pino-contact-copy]');
      if (!form || !copyElement) return;
      let copy;
      try {
        copy = JSON.parse(copyElement.textContent);
      } catch {
        return;
      }
      field.dataset.pinoInitialized = 'true';

      const storageKey = `pino-contact-draft:${window.location.pathname}`;
      const clearDraft = () => {
        try {
          window.sessionStorage.removeItem(storageKey);
        } catch {}
      };
      const readDraft = () => {
        try {
          const saved = JSON.parse(window.sessionStorage.getItem(storageKey) || 'null');
          if (!saved || saved.path !== window.location.pathname || !Number.isFinite(saved.at) || Date.now() - saved.at > 15 * 60 * 1000 || Date.now() < saved.at) {
            clearDraft();
            return null;
          }
          return saved;
        } catch {
          return null;
        }
      };
      const heading = document.querySelector('[data-pino-contact-page-title]');
      const sectionHeading = field.closest('.contact')?.querySelector('[data-pino-contact-heading]');
      const setHeading = (text) => {
        if (heading) heading.textContent = text;
        if (sectionHeading) {
          sectionHeading.textContent = text;
          sectionHeading.hidden = Boolean(heading);
          if (!heading) sectionHeading.classList.remove('visually-hidden');
        }
      };
      const saved = readDraft();
      if (field.dataset.pinoContactState === 'success') {
        const successCopy = copy.topics[saved?.intent];
        setHeading(successCopy?.title || copy.title);
        const success = field.querySelector('[data-pino-contact-success]');
        if (success) success.textContent = successCopy?.success || copy.success;
        clearDraft();
        return;
      }

      const subject = field.querySelector('[data-pino-contact-subject]');
      const reference = field.querySelector('[data-pino-product-reference]');
      const country = field.querySelector('[data-pino-contact-country]');
      const postcode = field.querySelector('[data-pino-contact-postcode]');
      const noPostcode = field.querySelector('[data-pino-contact-no-postcode]');
      const locality = field.querySelector('[data-pino-contact-locality]');
      const postcodeField = field.querySelector('[data-pino-contact-postcode-field]');
      const localityField = field.querySelector('[data-pino-contact-locality-field]');
      const variant = field.querySelector('[data-pino-contact-variant]');
      const quantity = field.querySelector('[data-pino-contact-quantity]');
      const message = field.querySelector('textarea');
      const requestTitle = field.querySelector('[data-pino-contact-request-title]');
      const productName = field.querySelector('[data-pino-contact-product-name]');
      const productOption = field.querySelector('[data-pino-contact-product-option]');
      const productContext = field.querySelector('[data-pino-contact-product-context]');
      const summary = field.querySelector('[data-pino-contact-product-summary]');
      const productTitle = field.querySelector('[data-pino-contact-product-title]');
      const notice = field.querySelector('[data-pino-contact-product-notice]');
      const linkEditor = field.querySelector('[data-pino-contact-link-editor]');
      if (!subject || !reference || !country || !postcode || !message) return;

      const restoreFromDraft = field.dataset.pinoContactState === 'error' && saved?.fields;
      if (restoreFromDraft) {
        form.querySelectorAll('input[name], select[name], textarea[name]').forEach((input) => {
          const value = saved.fields[input.name];
          if (!input.name.startsWith('contact[')) return;
          if (input.type === 'checkbox' && typeof value === 'boolean') input.checked = value;
          else if (typeof value === 'string') input.value = value;
        });
        const restored = field.querySelector('[data-pino-contact-restored]');
        if (restored) restored.hidden = false;
        clearDraft();
      }

      const rootUrl = field.dataset.pinoRootUrl;
      const validRoot = /^\/(?:[a-z0-9]+(?:-[a-z0-9]+)*\/?)*$/i.test(rootUrl || '');
      const handle = uniqueParam('product');
      const validProduct = /^[a-z0-9][a-z0-9-]{0,254}$/.test(handle) && validRoot;
      const variantId = uniqueParam('variant');
      if (!restoreFromDraft && validProduct && !reference.value.trim()) {
        const productUrl = new URL(`${rootUrl.replace(/\/?$/, '/')}products/${handle}`, window.location.origin);
        if (/^\d{1,20}$/.test(variantId)) productUrl.searchParams.set('variant', variantId);
        reference.value = productUrl.href;
      }
      const intent = params.getAll('intent').length === 0 && validProduct ? 'shipping_quote' : uniqueParam('intent');
      const option = Array.from(subject.options).find((item) => item.dataset.intent === intent);
      if (!restoreFromDraft && option && !subject.value) subject.value = option.value;
      const destinationCountry = uniqueParam('delivery_country');
      if (!restoreFromDraft && !country.value && Array.from(country.options).some((item) => item.value === destinationCountry)) country.value = destinationCountry;
      const destinationPostcode = uniqueParam('delivery_postcode').trim();
      if (!restoreFromDraft && !postcode.value && /^[\p{L}\p{N} -]{1,24}$/u.test(destinationPostcode)) postcode.value = destinationPostcode;
      const destinationLocality = uniqueParam('delivery_locality').trim();
      const noPostcodeFlag = uniqueParam('delivery_no_postcode');
      const validLocality = destinationLocality.length <= 160 && /^[\p{L}\p{N}\p{P}\p{Zs}]+$/u.test(destinationLocality);
      const explicitNoPostcode = noPostcodeFlag === '1' || params.getAll('delivery_no_postcode').length === 0;
      if (!restoreFromDraft && noPostcode && locality && validLocality && explicitNoPostcode) {
        noPostcode.checked = true;
        if (!locality.value) locality.value = destinationLocality;
      }
      if (!restoreFromDraft && variant && validProduct && /^\d{1,20}$/.test(variantId) && !variant.value) variant.value = variantId;
      const requestedQuantity = uniqueParam('quantity');
      if (!restoreFromDraft && quantity && validProduct && /^[1-9]\d{0,8}$/.test(requestedQuantity) && !quantity.value) quantity.value = requestedQuantity;

      const currentIntent = () => subject.selectedOptions[0]?.dataset.intent || '';
      const updateDestination = () => {
        const shipping = currentIntent() === 'shipping_quote';
        const withoutPostcode = Boolean(noPostcode?.checked);
        country.required = shipping;
        country.setAttribute('aria-required', String(shipping));
        if (noPostcode) noPostcode.disabled = !shipping;
        postcode.disabled = !shipping || withoutPostcode;
        postcode.required = shipping && !withoutPostcode;
        postcode.setAttribute('aria-required', String(postcode.required));
        if (postcodeField) postcodeField.hidden = shipping && withoutPostcode;
        if (locality) {
          locality.disabled = !shipping || !withoutPostcode;
          locality.required = shipping && withoutPostcode;
          locality.setAttribute('aria-required', String(locality.required));
        }
        if (localityField) localityField.hidden = !shipping || !withoutPostcode;
      };
      const referenceUrl = () => {
        try {
          const url = new URL(reference.value.trim());
          return ['https:', 'http:'].includes(url.protocol) ? url : null;
        } catch {
          return null;
        }
      };
      const updateProductContext = () => {
        const selectedIntent = currentIntent();
        const selling = selectedIntent === 'selling';
        const fullContext = ['inquiry', 'shipping_quote', 'hold', 'waitlist', 'rental'].includes(selectedIntent);
        const label = selectedIntent === 'sourcing' ? copy.exampleLabel : copy.productLabel;
        reference.disabled = selling;
        if (productName) productName.disabled = selling;
        if (variant) variant.disabled = selling || !fullContext;
        if (quantity) quantity.disabled = selling || !fullContext;
        if (productOption) productOption.disabled = selling || !fullContext;
        if (linkEditor) linkEditor.hidden = selling;
        if (summary) summary.hidden = selling || !referenceUrl();
        const productLabel = field.querySelector('[data-pino-contact-product-label]');
        if (productLabel) productLabel.textContent = label;
        if (productContext) {
          productContext.value = label;
          productContext.disabled = selling || !referenceUrl();
        }
        const variantRow = field.querySelector('[data-pino-contact-option-row]');
        const quantityRow = field.querySelector('[data-pino-contact-quantity-row]');
        const variantText = field.querySelector('[data-pino-contact-option-text]');
        const quantityText = field.querySelector('[data-pino-contact-quantity-text]');
        if (variantRow) variantRow.hidden = !fullContext || !productOption?.value;
        if (quantityRow) quantityRow.hidden = !fullContext || !quantity?.value;
        if (variantText) variantText.textContent = productOption?.value || '';
        if (quantityText) quantityText.textContent = quantity?.value || '';
      };
      const updateTopic = () => {
        const selectedIntent = currentIntent();
        const topic = copy.topics[selectedIntent];
        setHeading(topic?.title || copy.title);
        const intro = field.querySelector('[data-pino-contact-intro]');
        const help = field.querySelector('[data-pino-contact-body-help]');
        const submit = field.querySelector('[data-pino-contact-submit]');
        if (intro) intro.textContent = topic?.intro || copy.intro;
        if (help) help.textContent = selectedIntent === 'shipping_quote' && !referenceUrl() ? copy.shippingNoProduct : topic?.body_help || copy.bodyHelp;
        if (submit) submit.textContent = topic?.send || copy.send;
        if (requestTitle) requestTitle.value = topic?.title || '';
        subject.setCustomValidity(selectedIntent ? '' : copy.topicRequired);
        field.querySelectorAll('[data-pino-contact-topics]').forEach((group) => {
          const active = group.dataset.pinoContactTopics.split(' ').includes(selectedIntent);
          group.hidden = !active;
          group.disabled = !active;
        });
        const shipping = selectedIntent === 'shipping_quote';
        updateDestination();
        message.required = !shipping || !referenceUrl();
        message.setAttribute('aria-required', String(message.required));
        const messageRequired = field.querySelector('[data-pino-contact-message-required]');
        if (messageRequired) messageRequired.hidden = !message.required;
        const locationLabel = field.querySelector('[data-pino-contact-location-label]');
        const timingLabel = field.querySelector('[data-pino-contact-timing-label]');
        if (locationLabel) locationLabel.textContent = `${selectedIntent === 'rental' ? copy.locationRental : copy.locationSelling} (${copy.optional})`;
        if (timingLabel) timingLabel.textContent = `${selectedIntent === 'rental' ? copy.timingRental : copy.timingProject} (${copy.optional})`;
        if (linkEditor && !reference.value.trim() && document.activeElement !== reference) linkEditor.open = ['inquiry', 'shipping_quote', 'hold', 'waitlist'].includes(selectedIntent);
        updateProductContext();
      };

      let requestVersion = 0;
      let controller;
      const updateSummary = () => {
        const url = referenceUrl();
        reference.setCustomValidity(reference.value.trim() && !url ? copy.invalidLink : '');
        if (summary) summary.hidden = !url;
        if (productTitle) {
          productTitle.textContent = url?.href || '';
          if (url) productTitle.href = url.href;
          else productTitle.removeAttribute('href');
        }
        if (notice) notice.hidden = true;
        updateProductContext();
      };
      const loadProduct = async () => {
        const url = referenceUrl();
        const version = ++requestVersion;
        controller?.abort();
        controller = new AbortController();
        updateSummary();
        if (!url || url.origin !== window.location.origin || !validRoot) return;
        const productMatch = url.pathname.match(/\/(?:collections\/[^/]+\/)?products\/([a-z0-9][a-z0-9-]{0,254})\/?$/);
        if (!productMatch) return;
        const productHandle = productMatch[1];
        try {
          const response = await fetch(`${rootUrl.replace(/\/?$/, '/')}products/${productHandle}.js`, { signal: controller.signal, credentials: 'same-origin' });
          if (!response.ok) throw new Error('Product unavailable');
          const product = await response.json();
          if (version !== requestVersion) return;
          if (product.handle !== productHandle || typeof product.title !== 'string') throw new Error('Product mismatch');
          if (productTitle) productTitle.textContent = product.title;
          if (productName) productName.value = product.title;
          const chosen = Array.isArray(product.variants) ? product.variants.find((item) => String(item.id) === variant?.value) : null;
          if (variant?.value && !chosen) {
            variant.value = '';
            if (quantity) quantity.value = '';
          }
          if (productOption) productOption.value = chosen?.title && chosen.title !== 'Default Title' ? chosen.title : '';
          updateProductContext();
        } catch (error) {
          if (version !== requestVersion || error.name === 'AbortError') return;
          if (notice) {
            notice.textContent = copy.unavailable;
            notice.hidden = false;
          }
        }
      };
      reference.addEventListener('input', () => {
        ++requestVersion;
        controller?.abort();
        if (variant) variant.value = '';
        if (quantity) quantity.value = '';
        if (productName) productName.value = '';
        if (productOption) productOption.value = '';
        updateSummary();
        updateTopic();
      });
      reference.addEventListener('change', loadProduct);
      subject.addEventListener('change', updateTopic);
      noPostcode?.addEventListener('change', updateDestination);
      form.addEventListener('submit', () => {
        const fields = {};
        form.querySelectorAll('input[name], select[name], textarea[name]').forEach((input) => {
          if (input.name.startsWith('contact[')) fields[input.name] = input.type === 'checkbox' ? input.checked : input.value;
        });
        try {
          window.sessionStorage.setItem(storageKey, JSON.stringify({ at: Date.now(), path: window.location.pathname, intent: currentIntent(), fields }));
        } catch {}
      });
      updateTopic();
      if (linkEditor && referenceUrl()) linkEditor.open = false;
      loadProduct();
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
